import React from 'react';
import styles from './TermosServico.module.css';

function TermsOfService() {
    return (
        <section className={styles.termsSection}>

            <article className={styles.section}>
                <p className={styles.sectionContent}>
                    <strong>1.</strong> Este Termo se refere ao <strong>GuardAí</strong>, um sistema de armários inteligentes para condomínios, incluindo este aplicativo.
                    Ao usar o aplicativo GuardAí, você confirma que LEU, COMPREENDEU e CONCORDA com nossos Termos de Serviço. Caso não concorde com algum ponto, recomendamos
                    que não utilize o aplicativo até sanar todas as suas dúvidas. Em caso de dúvidas, entre em contato pelo e-mail <strong>gestao@guardai.com.br</strong>.
                </p>
            </article>

            <article className={styles.section}>
                <h3 className={styles.sectionTitle}>Uso do Aplicativo</h3>
                <p className={styles.sectionContent}>
                    <strong>2.</strong> O aplicativo GuardAí é uma ferramenta essencial para o uso do sistema de armários inteligentes. Ele permite que usuários:
                </p>
                <ul className={styles.list}>
                    <li>Realizem o cadastro no sistema;</li>
                    <li>Recebam notificações e códigos de retirada de encomendas;</li>
                    <li>Acompanhem o histórico de suas encomendas;</li>
                    <li>Gerenciem informações do perfil de usuário.</li>
                </ul>
                <p className={styles.sectionContent}>
                    <strong>3.</strong> O uso do aplicativo requer a criação de uma conta com informações válidas. Os usuários são responsáveis por fornecer dados corretos
                    e manter suas credenciais de acesso em segurança. A GuardAí não se responsabiliza por uso indevido ou perda de acesso devido ao compartilhamento de credenciais.
                </p>
                <p className={styles.sectionContent}>
                    <strong>4.</strong> O aplicativo é destinado exclusivamente para maiores de 18 anos. Caso seja menor de idade, o uso só será permitido mediante autorização dos responsáveis legais.
                </p>
            </article>

            <article className={styles.section}>
                <h3 className={styles.sectionTitle}>Restrições de Uso</h3>
                <p className={styles.sectionContent}>
                    <strong>5.</strong> O GuardAí reserva-se o direito de restringir ou suspender o acesso ao aplicativo em caso de:
                </p>
                <ul className={styles.list}>
                    <li>Fornecimento de informações falsas ou enganosas durante o cadastro;</li>
                    <li>Uso indevido do aplicativo para fins contrários à lei ou aos princípios éticos;</li>
                    <li>Atividades que comprometam a segurança do sistema ou de outros usuários;</li>
                    <li>Violação dos Termos de Serviço ou da Política de Privacidade.</li>
                </ul>
            </article>

            <article className={styles.section}>
                <h3 className={styles.sectionTitle}>Propriedade Intelectual</h3>
                <p className={styles.sectionContent}>
                    <strong>6.</strong> Todo o conteúdo, design, funcionalidades e tecnologia do GuardAí são protegidos por direitos de propriedade intelectual.
                    O uso indevido, reprodução ou redistribuição não autorizada dos materiais do GuardAí são estritamente proibidos e podem levar a penalidades legais.
                </p>
            </article>

            <article className={styles.section}>
                <h3 className={styles.sectionTitle}>Privacidade e Dados do Usuário</h3>
                <p className={styles.sectionContent}>
                    <strong>7.</strong> O GuardAí coleta e processa informações pessoais dos usuários conforme descrito na nossa <a href="/politica-de-privacidade" target="_blank" className={styles.link}>Política de Privacidade</a>.
                    Ao utilizar o aplicativo, você concorda com a coleta e uso dessas informações para o funcionamento do sistema.
                </p>
            </article>

            <article className={styles.section}>
                <h3 className={styles.sectionTitle}>Isenção de Responsabilidade</h3>
                <p className={styles.sectionContent}>
                    <strong>8.</strong> A GuardAí não se responsabiliza por danos diretos ou indiretos decorrentes do uso do aplicativo, incluindo, mas não se limitando a,
                    falhas técnicas, perda de dados ou interrupções nos serviços. O uso do aplicativo é feito por conta e risco do usuário.
                </p>
            </article>

            <article className={styles.section}>
                <h3 className={styles.sectionTitle}>Alterações nos Termos</h3>
                <p className={styles.sectionContent}>
                    <strong>9.</strong> O GuardAí reserva-se o direito de revisar e alterar estes Termos de Serviço a qualquer momento. Recomendamos que os usuários
                    revisem periodicamente os Termos para se manterem atualizados.
                </p>
            </article>

            <article className={styles.section}>
                <h3 className={styles.sectionTitle}>Contato</h3>
                <p className={styles.sectionContent}>
                    <strong>10.</strong> Caso tenha dúvidas sobre os Termos de Serviço ou precise de assistência, entre em contato pelo e-mail <strong>gestao@guardai.com.br</strong>.
                </p>
                <p className={styles.sectionContent}>
                    <strong>11.</strong> Estes Termos são regidos pelas leis brasileiras. Qualquer disputa relacionada ao uso do aplicativo deverá ser resolvida no foro de Fortaleza, Ceará, Brasil.
                </p>
            </article>
        </section>
    );
}

export default TermsOfService;
